// import { Modal } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { useRef, useState, useEffect } from "react";
// import { MdOutlineKeyboardAlt } from "react-icons/md";
// import Keyboard from "react-simple-keyboard";

// const useStyles = makeStyles(() => ({
//   smsCodeVerification: {
//     margin: "30px auto 0 auto",
//     width: "auto",
//     height: "auto",
//     textAlign: "center",
//     direction: "ltr",
//     borderRadius: 5,
//     fontSize: 20,
//     "& input": {
//       border: "1px solid #e1e1e1",
//       fontSize: "20px !important",
//       height: 50,
//       textAlign: "center",
//       width: 50,
//       borderRadius: 5,
//       margin: 5,
//       "&[type=number]": {
//         MozAppearance: "textfield",
//       },
//       "&[type=number]::-webkit-outer-spin-button": {
//         WebkitAppearance: "none",
//         margin: 0,
//       },
//       "&[type=number]::-webkit-inner-spin-button": {
//         WebkitAppearance: "none",
//         margin: 0,
//       },
//       "&:focus": {
//         border: "1px solid #099C55",
//         fontSize: 20,
//         outline: 0,
//       },
//       "&::placeholder": {
//         color: "black",
//         position: "relative",
//         top: -5,
//       },
//     },
//   },
//   keyboardStyle: {
//     display: "flex",
//     backgroundColor: "#ffffff",
//     zIndex: 100,
//     borderRadius: 5,
//     position: "absolute",
//     top: "50%",
//     left: "49%",
//     transform: "translate(-50%, -18%)",
//     outline: 0,
//     border: 0,
//     boxShadow: 24,
//     maxWidth: "100%",
//     width: "auto",
//     maxHeight: "80vh",
//     overflowY: "auto",
//   },
// }));

// export default function Otp({
//   InputSmsCode,
//   setInputSmsCode,
//   numberOtp,
//   submiting,
// }) {
//   const classes = useStyles();
//   const refs = useRef([]);
//   const [showKeyPass, setShowKeyPass] = useState(false);
//   const [layoutName, setLayoutName] = useState("default");
//   const [inputPass, setInputPass] = useState("");

//   const activeIndexes = [0, 1, 2, 3, 4];

//   useEffect(() => {
//     if (refs.current[activeIndexes[0]]) {
//       refs.current[activeIndexes[0]].focus();
//     }
//   }, []);

//   const handleChangeSmsCodeInput = (value, index) => {
//     if (!activeIndexes.includes(index)) return;

//     setInputSmsCode((prev) => ({
//       ...prev,
//       [index]: value,
//     }));

//     const nextIndex = activeIndexes[activeIndexes.indexOf(index) + 1];
//     if (value && refs.current[nextIndex]) {
//       refs.current[nextIndex].focus();
//     }

//     if (
//       activeIndexes.every(
//         (i) => Object.values({ ...InputSmsCode, [index]: value })[i] !== ""
//       )
//     ) {
//       // submiting();
//     }
//   };

//   const handlePaste = (e) => {
//     const paste = e.clipboardData.getData("text");
//     const pasteValues = paste.split("");

//     activeIndexes.forEach((index, i) => {
//       if (pasteValues[i]) {
//         handleChangeSmsCodeInput(pasteValues[i], index);
//       }
//     });
//   };

//   const handleKeyDown = (e, index) => {
//     if (
//       e.key === "Backspace" &&
//       !InputSmsCode[index] &&
//       activeIndexes.includes(index)
//     ) {
//       const prevIndex = activeIndexes[activeIndexes.indexOf(index) - 1];
//       if (refs.current[prevIndex]) {
//         refs.current[prevIndex].focus();
//       }
//     }
//   };

//   const onChange = (newInput) => {
//     if (showKeyPass) {
//       newInput.split("").forEach((char, i) => {
//         handleChangeSmsCodeInput(char, activeIndexes[i]);
//       });

//       setInputPass(newInput);
//     }
//   };

//   return (
//     <section className={classes.smsCodeVerification}>
//       <div className="w-100">
//         <form
//           name="verifyForm"
//           onPaste={handlePaste}
//           autoComplete="one-time-code"
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               justifyContent: "center",
//             }}
//             className="inputs d-flex justify-content-center align-content-center w-150"
//           >
//             <MdOutlineKeyboardAlt
//               onClick={() => setShowKeyPass((prev) => !prev)}
//               size={25}
//               style={{ cursor: "pointer" }}
//             />
//             {[...Array(numberOtp)].map((_, i) => (
//               <input
//                 key={i}
//                 ref={(el) => (refs.current[i] = el)}
//                 autoComplete="one-time-code"
//                 inputmode="numeric"
//                 pattern="\d{1}"
//                 type="tel"
//                 name={`one-time-code${i + 1}`}
//                 maxLength="1"
//                 value={InputSmsCode[i] || ""}
//                 onChange={(e) => handleChangeSmsCodeInput(e.target.value, i)}
//                 onKeyDown={(e) => handleKeyDown(e, i)}
//                 disabled={!activeIndexes.includes(i)}
//               />
//             ))}
//           </div>
//           <button style={{ display: "none" }} type="submit"></button>
//         </form>

//         {showKeyPass && (
//           <Modal
//             sx={{
//               "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
//                 backgroundColor: "transparent",
//               },
//             }}
//             open={showKeyPass}
//             onClose={() => {
//               setShowKeyPass(false);
//             }}
//             aria-labelledby="simple-modal-title"
//             aria-describedby="simple-modal-description"
//           >
//             <div className={classes.keyboardStyle}>
//               <div style={{ direction: "ltr" }}>
//                 <Keyboard
//                   input={inputPass}
//                   layoutName={layoutName}
//                   onChange={onChange}
//                 />
//               </div>
//             </div>
//           </Modal>
//         )}
//       </div>
//     </section>
//   );
// }
import { Modal } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef, useState, useEffect } from "react";
import { MdOutlineKeyboardAlt } from "react-icons/md";
import Keyboard from "react-simple-keyboard";

const useStyles = makeStyles((theme) => ({
  smsCodeVerification: {
    margin: "5px auto 0 auto",
    width: "auto",
    height: "auto",
    textAlign: "center",
    direction: "ltr",
    borderRadius: 5,
    fontSize: 20,
    "& input": {
      border: `1px solid ${theme.palette.divider}`,
      fontSize: "20px !important",
      height: 50,
      textAlign: "center",
      width: 50,
      borderRadius: 5,
      margin: 5,
      "&[type=number]": {
        MozAppearance: "textfield",
      },
      "&[type=number]::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&[type=number]::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&:focus": {
        border: `1px solid ${theme.palette.primary.main}`,
        fontSize: 20,
        outline: 0,
      },
      "&::placeholder": {
        color: "black",
        position: "relative",
        top: -5,
      },
    },
  },
  keyboardStyle: {
    display: "flex",
    backgroundColor: "#ffffff",
    zIndex: 100,
    borderRadius: 5,
    position: "absolute",
    top: "50%",
    left: "49%",
    transform: "translate(-50%, -18%)",
    outline: 0,
    border: 0,
    boxShadow: 24,
    maxWidth: "100%",
    width: "auto",
    maxHeight: "80vh",
    overflowY: "auto",
  },
}));

export default function Otp({
  InputSmsCode,
  setInputSmsCode,
  numberOtp,
  submiting,
}) {
  const classes = useStyles();
  const refs = useRef([]);
  const [showKeyPass, setShowKeyPass] = useState(false);
  const [layoutName, setLayoutName] = useState("default");

  useEffect(() => {
    const handleOtpReceived = (event) => {
      const otp = event.detail.code;

      const otpNumberMatch = otp.match(/Code:\s*(\d+)/);
      if (otpNumberMatch && otpNumberMatch[1]) {
        const otpNumber = otpNumberMatch[1];

        // پر کردن ورودی‌ها
        otpNumber.split("").forEach((digit, index) => {
          handleChangeSmsCodeInput(digit, index);
        });
      } else {
        console.error("OTP code not found in the message.");
      }
    };

    window.addEventListener("otpreceived", handleOtpReceived);

    return () => {
      window.removeEventListener("otpreceived", handleOtpReceived);
    };
  }, []);

  // Handle changes in OTP inputs
  const handleChangeSmsCodeInput = (value, index) => {
    if (!/^[0-9\u0660-\u0669\u06F0-\u06F9]?$/.test(value)) return;

    setInputSmsCode((prev) => ({
      ...prev,
      [index]: value,
    }));

    const nextIndex = index + 1;
    if (value && refs.current[nextIndex]) {
      refs.current[nextIndex].focus();
    }

    // If all fields are filled, call submiting function
    if (
      Object.values({ ...InputSmsCode, [index]: value }).join("").length ===
      numberOtp
    ) {
      // submiting();
    }
  };

  // Handle pasting OTP code from clipboard
  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").slice(0, numberOtp);
    const pasteValues = paste.split("");

    pasteValues.forEach((digit, i) => {
      handleChangeSmsCodeInput(digit, i);
    });
  };

  // Handle backspace in inputs
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !InputSmsCode[index]) {
      const prevIndex = index - 1;
      if (refs.current[prevIndex]) {
        refs.current[prevIndex].focus();
      }
    }
  };

  // Handle virtual keyboard input change
  const onChange = (newInput) => {
    if (showKeyPass) {
      newInput.split("").forEach((char, i) => {
        handleChangeSmsCodeInput(char, i);
      });
    }
  };

  return (
    <section className={classes.smsCodeVerification}>
      <div className="w-100">
        <form
          name="verifyForm"
          onPaste={handlePaste}
          autoComplete="one-time-code"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
            className="inputs d-flex justify-content-center align-content-center w-150"
          >
            <MdOutlineKeyboardAlt
              onClick={() => setShowKeyPass((prev) => !prev)}
              size={25}
              style={{ cursor: "pointer" }}
            />
            {[...Array(numberOtp)].map((_, i) => (
              <input
                key={i}
                ref={(el) => (refs.current[i] = el)}
                autoComplete="one-time-code"
                inputMode="numeric"
                type="tel"
                name={`otp-${i}`}
                maxLength="1"
                value={InputSmsCode[i] || ""}
                onChange={(e) => handleChangeSmsCodeInput(e.target.value, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
              />
            ))}
          </div>
          <button style={{ display: "none" }} type="submit"></button>
        </form>

        {showKeyPass && (
          <Modal
            sx={{
              "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                backgroundColor: "transparent",
              },
            }}
            open={showKeyPass}
            onClose={() => {
              setShowKeyPass(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className={classes.keyboardStyle}>
              <div style={{ direction: "ltr" }}>
                <Keyboard
                  input={Object.values(InputSmsCode).join("")}
                  layoutName={layoutName}
                  onChange={onChange}
                />
              </div>
            </div>
          </Modal>
        )}
      </div>
    </section>
  );
}
